// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"a0ba127a","902":"80a446af"}[chunkId] + ".chunk.js";
};